export default class Modal {
	init() {
		this.modal();
	}
	modal(){
		$(function(){
			$('.js_modal').colorbox({
				inline: true,
				opacity: 1,
				maxWidth: "100%",
				scrolling: false,
			});
		});
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/modal.js